import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import { beforeGuard } from './guard/index'
import Layout from '../views/layout/index.vue'
import Login from '../views/Login.vue'
import Setting from '../views/Setting.vue'
import Users from '../views/Users.vue'
import Updata from '../views/Updata.vue'
import Store from '../views/Store.vue'
import Logs from '../views/Logs.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: '数据统计',
    redirect: '/updata',
  },
  {
    name: '登录',
    path: '/login',
    component: Login
  },
  {
    path: '/updata',
    name: '更新数据',
    component: Layout,
    children:[
      {
        name: '更新数据',
        path: '/updata',
        component: Updata,
      }
    ]
  },
  {
    path: '/setting',
    name: '仓库设置',
    component: Layout,
    children:[
      {
        name: '仓库设置',
        path: '/setting',
        component: Setting,
      }
    ]
  },
  {
    path: '/users',
    name: '账号管理',
    component: Layout,
    children:[
      {
        name: '账号列表',
        path: '/users',
        component: Users,
      }
    ]
  },
  {
    path: '/store',
    name: '店铺设置',
    component: Layout,
    children:[
      {
        name: '店铺设置',
        path: '/store',
        component: Store,
      }
    ]
  },
  {
    path: '/logs',
    name: '日志',
    component: Layout,
    children:[
      {
        name: '日志',
        path: '/logs',
        component: Logs,
      }
    ]
  },
]
const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  try {
      /* 检测路径 */
      await beforeGuard.rediectPath(to, from, next)

      /* 调整路由参数 */
      await beforeGuard.parsePath(to, from, next)
      
      /* 检测登录状态 */
      await beforeGuard.checkLogin(to, from, next)
      
      /* 检测权限 */
      await beforeGuard.checkPerm({ to, from, next })
  } catch (error) {
      console.log(error)
  }
})

export default router
